export function readNumber(
    params: URLSearchParams,
    key: string,
    fallback: number,
    min = -Infinity,
    max = Infinity,
) {
    const raw = params.get(key);
    if (raw === null || raw.trim() === "") {
        return fallback;
    }
    const value = Number(raw);
    return Number.isFinite(value) && value >= min && value <= max
        ? value
        : fallback;
}

export function readChoice<T extends string>(
    params: URLSearchParams,
    key: string,
    choices: readonly T[],
    fallback: T,
) {
    const value = params.get(key);
    return value !== null && choices.includes(value as T)
        ? (value as T)
        : fallback;
}

export function readFlag(
    params: URLSearchParams,
    key: string,
    fallback: "0" | "1",
): "0" | "1" {
    const value = params.get(key)?.toLowerCase();
    if (value === "1" || value === "on" || value === "true") {
        return "1";
    }
    if (value === "0" || value === "off" || value === "false") {
        return "0";
    }
    return fallback;
}

export function readColor(
    params: URLSearchParams,
    key: string,
    fallback: string,
) {
    const value = params.get(key);
    return value && /^#[0-9a-f]{6}([0-9a-f]{2})?$/i.test(value)
        ? value
        : fallback;
}
